export const isUSCountry = (country: string) =>
  country === 'US' ||
  country === 'U.S.A' ||
  country === 'U.S.A.' ||
  country === 'USA' ||
  country === 'United States' ||
  country === 'United States of America';
